var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c(
            "Loading",
            {
              attrs: {
                visible: _vm.loading,
                message: "Caricamento ordine spacchettato...",
                templateType: _vm.loadTemplateCorrente,
              },
            },
            [
              _c(
                "div",
                [
                  _vm.ordine && _vm.ordine != null
                    ? _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", "offset-xs1": "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  _c(
                                    "v-card-text",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c("v-flex", { attrs: { xs8: "" } }, [
                                            _c(
                                              "h3",
                                              { staticClass: "headline mb-0" },
                                              [
                                                _vm._v(" ORDINE NR: "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.ordine.ordineNumero
                                                    ) +
                                                      " / " +
                                                      _vm._s(
                                                        _vm.ordine.ordineLinea
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" DEL "),
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("formatDate")(
                                                        _vm.ordine.dataOrdine
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("div", [
                                              _vm._v(" DATA SCADENZA: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatDate")(
                                                      _vm.ordine.dataScadenza
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v(" STATO: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.ordine.statoOrdine)
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v(" STAGIONE: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine
                                                      .stagioneDecodificata.id
                                                  ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.ordine
                                                        .stagioneDecodificata
                                                        .descrizione
                                                    )
                                                ),
                                              ]),
                                            ]),
                                            _vm.ordine.lineaVenditaDecodificata
                                              ? _c("div", [
                                                  _vm._v(" LINEA DI VENDITA: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ordine
                                                          .lineaVenditaDecodificata
                                                          .id
                                                      ) +
                                                        " - " +
                                                        _vm._s(
                                                          _vm.ordine
                                                            .lineaVenditaDecodificata
                                                            .descrizione
                                                        )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _c("div", [
                                              _vm._v(" FASE: "),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.ordine
                                                      .faseDecodificata &&
                                                      `${_vm.ordine.faseDecodificata.id} ${_vm.ordine.faseDecodificata.descrizione}`
                                                  )
                                                ),
                                              ]),
                                            ]),
                                            _c("div", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.ordine.campionarietto
                                                      ? "CAMPIONARIO"
                                                      : "PRODUZIONE"
                                                  )
                                              ),
                                              _vm.ordine.firstCost == "S"
                                                ? _c("span", [
                                                    _c("strong", [
                                                      _vm._v(" USA"),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                          ]),
                                          _c("v-flex", { attrs: { xs4: "" } }, [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "right",
                                                },
                                              },
                                              [
                                                _c(
                                                  "h2",
                                                  {
                                                    staticStyle: {
                                                      float: "right",
                                                      margin: "0 10px 20px 0",
                                                      "item-aligns": "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticStyle: {
                                                          "vertical-align":
                                                            "middle",
                                                        },
                                                        attrs: {
                                                          large: "",
                                                          color:
                                                            "blue darken-2",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "statoOrdineIco"
                                                              )(
                                                                _vm.ordine.stato
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.ordine.stato
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.ordDettaglio && _vm.ordDettaglio.length
                            ? _c(
                                "v-flex",
                                { attrs: { xs10: "", "offset-xs1": "" } },
                                [
                                  _c("v-card-title", [
                                    _c("h2", [_vm._v("Righe")]),
                                  ]),
                                  _c(
                                    "v-list",
                                    {
                                      style: { padding: "0" },
                                      attrs: {
                                        "two-line": _vm.compact,
                                        "three-line": !_vm.compact,
                                      },
                                    },
                                    _vm._l(
                                      _vm.ordDettaglio,
                                      function (lavorazione, i) {
                                        return _c(
                                          "v-card",
                                          {
                                            key: i,
                                            class: {
                                              "riga-alt":
                                                _vm.infoRighe[i].classe ===
                                                "rigaAlt",
                                            },
                                            style: {
                                              "margin-top":
                                                _vm.infoRighe[i].marginTop +
                                                "px",
                                            },
                                          },
                                          [
                                            lavorazione
                                              ? _c(
                                                  "v-list-item",
                                                  { attrs: { "two-line": "" } },
                                                  [
                                                    _c(
                                                      "v-list-item-content",
                                                      [
                                                        _c(
                                                          "v-list-item-title",
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    lavorazione.idLakpet
                                                                  ) +
                                                                  " "
                                                              ),
                                                              lavorazione.firstCost ==
                                                              "S"
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      "USA"
                                                                    ),
                                                                  ])
                                                                : _vm._e(),
                                                            ]),
                                                            _vm._v(
                                                              " Ordine N. "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.ordineNumero
                                                                ) +
                                                                  " / " +
                                                                  _vm._s(
                                                                    lavorazione.ordineLinea
                                                                  )
                                                              ),
                                                            ]),
                                                            _vm._v(" del "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "formatDate"
                                                                  )(
                                                                    lavorazione.dataOrdine
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              ", Stagione: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.stagioneDecodificata &&
                                                                    `${lavorazione.stagioneDecodificata.id} ${lavorazione.stagioneDecodificata.descrizione}`
                                                                ) + " "
                                                              ),
                                                            ]),
                                                            _vm._v(" , "),
                                                            lavorazione.lineaVendita
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    " Linea vendita: "
                                                                  ),
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        lavorazione.lineaVenditaDecodificata &&
                                                                          `${lavorazione.lineaVenditaDecodificata.id} ${lavorazione.lineaVenditaDecodificata.descrizione}`
                                                                      )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(", "),
                                                                ])
                                                              : _vm._e(),
                                                            _vm._v(" Fase: "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.faseDecodificata &&
                                                                    `${lavorazione.faseDecodificata.id} ${lavorazione.faseDecodificata.descrizione}`
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-list-item-subtitle",
                                                          [
                                                            _vm._v(" Lotto: "),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.lotto
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " Consegna: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.codiceConsegna
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " , Modello: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  (lavorazione.modelloDecodificato &&
                                                                    `${lavorazione.modelloDecodificato.codiceParte} ${lavorazione.modelloDecodificato.descrizione}`) ||
                                                                    lavorazione.modello
                                                                ) + " "
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              ", Colore: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  (lavorazione.coloreDecodificato &&
                                                                    `${lavorazione.coloreDecodificato.codiceColore} ${lavorazione.coloreDecodificato.descrizione}`) ||
                                                                    lavorazione.colore
                                                                )
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              ", Numero capi: "
                                                            ),
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  lavorazione.qtaTotale
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _c(
                                                          "v-data-table",
                                                          {
                                                            staticClass:
                                                              "grigliaTaglie",
                                                            attrs: {
                                                              items:
                                                                _vm.getItemsTaglie(
                                                                  lavorazione
                                                                ),
                                                              "hide-default-footer":
                                                                "",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "header",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "thead",
                                                                        {
                                                                          staticClass:
                                                                            "v-data-table-header",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "tr",
                                                                            _vm._l(
                                                                              _vm.getHeadersTaglie(
                                                                                lavorazione
                                                                              ),
                                                                              function (
                                                                                header,
                                                                                index
                                                                              ) {
                                                                                return _c(
                                                                                  "th",
                                                                                  {
                                                                                    key:
                                                                                      "head_" +
                                                                                      index,
                                                                                    staticClass:
                                                                                      "text-center",
                                                                                  },
                                                                                  [
                                                                                    header.barcode
                                                                                      ? _c(
                                                                                          "div",
                                                                                          [
                                                                                            _c(
                                                                                              "v-tooltip",
                                                                                              {
                                                                                                attrs:
                                                                                                  {
                                                                                                    top: "",
                                                                                                  },
                                                                                                scopedSlots:
                                                                                                  _vm._u(
                                                                                                    [
                                                                                                      {
                                                                                                        key: "activator",
                                                                                                        fn: function ({
                                                                                                          on,
                                                                                                        }) {
                                                                                                          return undefined
                                                                                                        },
                                                                                                      },
                                                                                                    ],
                                                                                                    null,
                                                                                                    true
                                                                                                  ),
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        header.barcode
                                                                                                      )
                                                                                                    ),
                                                                                                  ]
                                                                                                ),
                                                                                              ]
                                                                                            ),
                                                                                          ],
                                                                                          1
                                                                                        )
                                                                                      : _vm._e(),
                                                                                    _vm._v(
                                                                                      " " +
                                                                                        _vm._s(
                                                                                          header.value
                                                                                        ) +
                                                                                        " "
                                                                                    ),
                                                                                  ]
                                                                                )
                                                                              }
                                                                            ),
                                                                            0
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                                {
                                                                  key: "item",
                                                                  fn: function ({
                                                                    item,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "tr",
                                                                        {
                                                                          staticClass:
                                                                            "rigaProgresso",
                                                                          attrs:
                                                                            {
                                                                              "data-test":
                                                                                "riga-progresso",
                                                                            },
                                                                        },
                                                                        [
                                                                          item.tipoRiga ==
                                                                          0
                                                                            ? _vm._l(
                                                                                item.values,
                                                                                function (
                                                                                  value,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "td",
                                                                                    {
                                                                                      key:
                                                                                        "tot_" +
                                                                                        index,
                                                                                      staticClass:
                                                                                        "rigaProgTot text-center",
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              "data-test":
                                                                                                "data-element-" +
                                                                                                index,
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              value
                                                                                            )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              )
                                                                            : _vm._e(),
                                                                        ],
                                                                        2
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot: "no-data",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-alert",
                                                                  {
                                                                    attrs: {
                                                                      value: true,
                                                                      color:
                                                                        "error",
                                                                      icon: "warning",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " Sorry, nothing to display here :( "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "v-list-item-action",
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              loading:
                                                                _vm.xlsxPackingListLavorazioneSpacchettatoLoading.indexOf(
                                                                  lavorazione.id
                                                                ) >= 0,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.downloadXLSXPackingListLavorazioneSpacchettato(
                                                                  lavorazione
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "pa-1",
                                                                attrs: {
                                                                  title:
                                                                    "Scarica XLSX Packing List Lavorazione",
                                                                  size: "25",
                                                                  color:
                                                                    "blue lighten-1",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-download"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "v-flex",
                                {
                                  staticStyle: { "font-size": "25px" },
                                  attrs: { xs10: "", "offset-xs1": "" },
                                },
                                [
                                  _vm._v(
                                    "OPPPSSS... Nessun dato da visualizzare."
                                  ),
                                ]
                              ),
                        ],
                        1
                      )
                    : _c("div", [
                        _vm._v("OPPPSSS... Nessun dato da visualizzare."),
                      ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }